const PropTypes = require('prop-types');
const React = require('react');

const RelatedArticleView = require('./related_article_view.jsx');

const RelatedArticlesView = ({ articles, onClick }) =>
  <div className="mb-3">
    <h4 className="strong serif mb-half">{I18n.t('js.articles.relatedArticles.title')}</h4>
    <div className="g-container">
      {articles.map(article =>
        <RelatedArticleView key={article.id} article={article} onClick={onClick} />)}
    </div>
  </div>;

RelatedArticlesView.propTypes = {
  articles: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
};

module.exports = RelatedArticlesView;



// WEBPACK FOOTER //
// ./javascripts/components/articles/related_articles_view.jsx